// extracted by mini-css-extract-plugin
module.exports = {"list":"_2eI6O-"};